import { useMemo, useCallback } from 'react';
import { useMerchants } from './use-merchants';

/**
 * Globaler Merchant-Lookup: merchantId → merchantName und merchantId → customerId.
 * Cached ueber React Query (5min staleTime aus useMerchants).
 * customerId stammt aus der Merchant-Liste (seit #306, auch Prod via Dual-Read-Fallback).
 */
export function useMerchantMap() {
  const { data } = useMerchants({ limit: 200 });

  const merchantMap = useMemo(() => {
    const m = new Map<string, string>();
    data?.data.forEach((merchant) => m.set(merchant.merchantId, merchant.name));
    return m;
  }, [data]);

  const customerIdMap = useMemo(() => {
    const m = new Map<string, string>();
    data?.data.forEach((merchant) => {
      if (merchant.customerId) m.set(merchant.merchantId, merchant.customerId);
    });
    return m;
  }, [data]);

  const resolveMerchantName = useCallback(
    (id: string) => merchantMap.get(id) ?? id,
    [merchantMap],
  );

  const resolveCustomerId = useCallback(
    (id: string): string | null => customerIdMap.get(id) ?? null,
    [customerIdMap],
  );

  return {
    merchantMap,
    customerIdMap,
    resolveMerchantName,
    resolveCustomerId,
    merchants: data?.data ?? [],
  };
}
